<template>
    <div style="position:relative;margin-bottom:20px;">
        <img :src="src" style="width:100%;margin-bottom:0px;" />
        <div v-if="text" style="position:absolute;right:0px;bottom:0px;background:#8b0000;color:#fff;font-size:12px;padding:2px 6px;" v-html="text">
        </div>
    </div>

</template>

<script>
export default {
    props: {
        src: { type: String, required: true },
        text: { type: String, required: false }
    }
}
</script>



// WEBPACK FOOTER //
// img-component.vue?7237fcc4